import { render, staticRenderFns } from "./course_comment_each.vue?vue&type=template&id=c69d9510&scoped=true&"
import script from "./course_comment_each.vue?vue&type=script&lang=js&"
export * from "./course_comment_each.vue?vue&type=script&lang=js&"
import style0 from "./course_comment_each.vue?vue&type=style&index=0&id=c69d9510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69d9510",
  null
  
)

export default component.exports